module.exports = __webpack_public_path__ + "img/close-up-hand-holding-house-model-against-textured-background.e629e426.jpg";